import { Flex } from 'shared';

import {
  JournalCard,
  JournalNote,
  JournalNoteCardReactions,
} from 'features/journal';
import { User } from 'features/user/User';

import { useSidebarContext } from 'shared/components/Sidebar/context';

type TJournalRepliesCard = {
  note: JournalNote;
  participantId: string;
  setEditedNode: () => void;
};

export const JournalRepliesCard = ({
  note,
  setEditedNode,
  participantId,
}: TJournalRepliesCard) => {
  const { user } = useSidebarContext() as { user: User };

  return (
    <JournalCard
      note={note}
      setEditedNote={setEditedNode}
      isAuthor={Boolean(user.userId === note.authorId)}
    >
      <Flex width="100%" justifyContent="flex-end">
        <JournalNoteCardReactions
          participantId={participantId}
          noteId={note.noteId}
          reactions={note.reactions}
          isNoteRead={note.isRead}
          user={user}
        />
      </Flex>
    </JournalCard>
  );
};
